<template>
  <v-row align="baseline">
    <v-col>
      <v-autocomplete
        v-model="localValue"
        :items="ownItems"
        :label="label"
        :error-messages="errorMessages"
        @change="$emit('input', localValue)"
        outlined
        :dense="dense"
        item-value="companyName"
        item-text="companyName"
        return-object
        :search-input.sync="search"
      >
        <template v-slot:selection="{ item }">
          {{ item.companyName }}
        </template>
        <template v-slot:no-data>
          <div class="text-center p-3 ma-2">{{ $t('common.notFound') }}<br />
            <v-btn
              rounded
              dark
              dense
              small
              color="primary"
              class="mt-md-2"
              @click="$emit('addNew', search)"
            >
              <v-icon> mdi-plus </v-icon>
              {{ $t('common.addNew') }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.companyName }}</v-list-item-title>
            <v-list-item-subtitle>{{ `${item.street} ${item.houseNumber}, ${item.zipCode} ${item.city}, ${item.state}` }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: 'AddressList',
  props: ['items', 'value', 'label', 'errorMessages', 'dense'],
  data () {
    return {
      localValue: this.value,
      search: ''
    }
  },
  computed: {
    ownItems () {
      return this.items.map((item) => ({ ...item, value: { ...item } }))
    }
  },
  watch: {
    value (v) {
      this.localValue = v
    }
  }
}
</script>
